import LogRocket from 'logrocket';
LogRocket.init('3gwxd3/abattoir');

export function identify(){
// This is an example script - don't forget to change it!
LogRocket.identify("user.uid", {
    name: "abattoir",
    email: "abattoir",
    // Add your own custom user variables here, ie:
    subscriptionType: 'pro'
  });
}

